import {
  DXREP,
  ExtensionModel,
} from '../../common/devexpress/Reporting/dx-react-reporting';
import type ko from 'knockout';

type ExtensionsCollection =
  | ExtensionModel[]
  | ko.ObservableArray<ExtensionModel>;

const unwrap = <T>(value: T | (() => T)): T =>
  typeof value === 'function' ? (value as () => T)() : value;

export function getExtensionValue(
  extensions: ExtensionsCollection,
  key: string,
) {
  const extension = getExtension(extensions, key) as any;
  const value = extension?.value ?? extension?._model?.value;
  return value ? unwrap(value) : value;
}

function getExtension(extensions: ExtensionsCollection, key: string) {
  return unwrap(extensions)?.find(
    (e: any) => unwrap(e?.key ?? e?._model?.key) === key,
  );
}

export function setExtensionValue(
  extensions: ExtensionsCollection,
  key: string,
  value: string,
) {
  const extension = getExtension(extensions, key);
  if (extension) {
    extension.value(value);
  } else {
    const newExtension = new DXREP.DxReportDesigner.ExtensionModel(
      { '@Key': key, '@Value': value },
      undefined,
    );

    extensions.push(newExtension as any);
  }
}
